import { render, staticRenderFns } from "./internal_direction.vue?vue&type=template&id=64c62e0a&scoped=true&"
import script from "./internal_direction.vue?vue&type=script&lang=js&"
export * from "./internal_direction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c62e0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64c62e0a')) {
      api.createRecord('64c62e0a', component.options)
    } else {
      api.reload('64c62e0a', component.options)
    }
    module.hot.accept("./internal_direction.vue?vue&type=template&id=64c62e0a&scoped=true&", function () {
      api.rerender('64c62e0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/internal_docs/edit/tabs/internal_direction.vue"
export default component.exports